const Promotion = () =>
  import(/* webpackChunkName: "promotion" */ '../views/Promotion.vue')

const PromotionRoute = [
  { // 👈 for webview
    path: '/promotion/:id',
    name: 'promotionmobile',
    component: Promotion,
    meta: {
      requiresAuth: false,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Promotion',
      backLink: 'dashboard',
    },
  },
  { // 👈 for web member
    path: '/promotion/detail/:id',
    name: 'promotion',
    component: Promotion,
    meta: {
      requiresAuth: true,
      hiddeMenu: true,
      navBar: true,
      navBarBack: true,
      title: 'Promotion',
      backLink: 'dashboard',
    },
  },
]

export default PromotionRoute
